<app-horizontal-navigation *ngIf="(screenSizeService.isHandset$ | async) === false; else handsetTemplate">
  <div class="customHorizontalNavContainer">
    <button
      mat-flat-button
      class="mr-2 horizontalNavButton"
      [routerLink]="SummaryTabs.CurrentDprSummary"
      routerLinkActive="mat-secondary"
      (click)="onSelectionChange(SummaryTabs.CurrentDprSummary)"
      data-testId="current-dpr-summary"
    >
      {{ currentDprSummaryLabel }}
    </button>

    <button
      mat-flat-button
      class="mr-2 horizontalNavButton"
      [routerLink]="SummaryTabs.Next24hPlanning"
      routerLinkActive="mat-secondary"
      (click)="onSelectionChange(SummaryTabs.Next24hPlanning)"
      data-testId="next-24h-planning"
    >
      {{ nextPlanningLabel }}
    </button>

    <button
      *ngIf="shouldDisplayExternalComment"
      mat-flat-button
      class="horizontalNavButton text-transform-initial"
      [routerLink]="SummaryTabs.ExternalPartyComment"
      routerLinkActive="mat-secondary"
      (click)="onSelectionChange(SummaryTabs.ExternalPartyComment)"
      data-testId="external-party-comment"
    >
      {{ externalCommentTabName }}
    </button>
  </div>
</app-horizontal-navigation>

<router-outlet (activate)="onComponentActivated($event)"></router-outlet>

<ng-template #handsetTemplate>
  <app-navigation-select
    [items]="navigationSelectItems"
    [initialSelection]="preselectedItem"
    (selectedItemChanges)="onSelectionChange($event)"
  ></app-navigation-select>
</ng-template>
